import { formatCodiceAgo } from "./codiceAgo";
import * as ExcelJS from "exceljs";

export function createClientiExportWorkbook(
  clienti,
  utenti,
  soloSenzaCodiceAgo = false,
) {
  const exportRows = clienti
    .filter(
      (cli) =>
        cli.Cessato !== 1 && (!soloSenzaCodiceAgo || !cli.CodiceAgo?.trim()),
    )
    .map((cli) => ({
      ragioneSociale: cli?.RagioneSociale || "",
      idKoala: cli.ID,
      codiceAgo: formatCodiceAgo(cli.CodiceAgo),
      codiceFiscale: cli.CF || "",
      piva: cli?.PIVA || "",
      indirizzo: cli?.SedeIndirizzo || "",
      localita: cli?.SedeLocalita || "",
      cap: cli?.SedeCAP || "",
      gestorePaghe: cli?.NomeReferente || "",
      utenteSicurezza: cli?.UtenteSicurezza
        ? utenti?.find((utente) => utente.ID === cli?.UtenteSicurezza)
            ?.username || ""
        : "",
      utenteMedicina: cli?.UtenteAssociato
        ? utenti?.find((utente) => utente.ID === cli?.UtenteAssociato)
            ?.username || ""
        : "",
      numeroDipendentiAttivi: cli?.NumeroDipendentiAttivi || 0,
    }));

  const workbook = new ExcelJS.Workbook();
  const worksheet = workbook.addWorksheet("Clienti");

  worksheet.columns = [
    { header: "Ragione Sociale", key: "ragioneSociale", width: 34 },
    { header: "ID Koala", key: "idKoala", width: 12 },
    {
      header: "Codice Ago",
      key: "codiceAgo",
      width: 18,
      style: { numFmt: "@" },
    },
    {
      header: "Codice fiscale",
      key: "codiceFiscale",
      width: 20,
      style: { numFmt: "@" },
    },
    { header: "Partita IVA", key: "piva", width: 18 },
    { header: "Indirizzo", key: "indirizzo", width: 32 },
    { header: "Località", key: "localita", width: 24 },
    { header: "Cap", key: "cap", width: 12 },
    { header: "Gestore Paghe", key: "gestorePaghe", width: 24 },
    { header: "Utente Sicurezza", key: "utenteSicurezza", width: 24 },
    { header: "Utente Medicina", key: "utenteMedicina", width: 24 },
    {
      header: "Numero dipendenti attivi",
      key: "numeroDipendentiAttivi",
      width: 26,
    },
  ];
  worksheet.addRows(exportRows);
  worksheet.views = [{ state: "frozen", ySplit: 1 }];
  worksheet.autoFilter = {
    from: "A1",
    to: { row: 1, column: worksheet.columnCount },
  };

  const headerRow = worksheet.getRow(1);
  headerRow.height = 22;
  headerRow.eachCell((cell) => {
    cell.font = { bold: true, color: { argb: "FFFFFFFF" } };
    cell.fill = {
      type: "pattern",
      pattern: "solid",
      fgColor: { argb: "FF11526F" },
    };
    cell.alignment = { vertical: "middle", horizontal: "center" };
    cell.border = {
      top: { style: "thin", color: { argb: "FFD8E2EA" } },
      left: { style: "thin", color: { argb: "FFD8E2EA" } },
      bottom: { style: "thin", color: { argb: "FFD8E2EA" } },
      right: { style: "thin", color: { argb: "FFD8E2EA" } },
    };
  });

  worksheet.eachRow((row, rowNumber) => {
    if (rowNumber === 1) return;
    row.eachCell((cell) => {
      cell.alignment = { vertical: "middle" };
      cell.border = {
        bottom: { style: "thin", color: { argb: "FFE5E7EB" } },
      };
    });
  });
  worksheet.getColumn("numeroDipendentiAttivi").alignment = {
    horizontal: "center",
  };

  return workbook;
}
